(function ($, abp) {
    var dateTimeFormatter = abp.dateTimeFormatter || {};

    dateTimeFormatter.getLongDateFormat = function () {
        return dateTimeFormatter.longDateFormat;
    };

    dateTimeFormatter.getLongDate2Format = function () {
        return dateTimeFormatter.longDate2Format;
    };

    dateTimeFormatter.getShortDateFormat = function () {
        return dateTimeFormatter.shortDateFormat;
    };

    dateTimeFormatter.getShortDate2Format = function () {
        return dateTimeFormatter.shortDate2Format;
    };

    dateTimeFormatter.getLongTimeFormat = function () {
        return dateTimeFormatter.longTimeFormat;
    };

    dateTimeFormatter.getShortTimeFormat = function () {
        return dateTimeFormatter.shortTimeFormat;
    };

    //#region Format to local format with local timezone

    /**
     * @description Formats a datetime to local long date. Eg: 03 February 2021
     * @param {(Date|string)} dateTime - If it's a string, make sure it's in ISO 8601 format. Eg: 2021-02-03T05:33:21Z / 2021-02-03T13:33:21+08:00
     * @returns {string} - The formatted long date.
     */
    dateTimeFormatter.formatLongDate = function (dateTime) {
        return window.moment(dateTime).format(abp.dateTimeFormatter.getLongDateFormat());
    };

    /**
     * @description Formats a datetime to local long date 2. Eg: Wednesday, 03 February 2021
     * @param {(Date|string)} dateTime - If it's a string, make sure it's in ISO 8601 format. Eg: 2021-02-03T05:33:21Z / 2021-02-03T13:33:21+08:00
     * @returns {string} - The formatted long date 2.
     */
    dateTimeFormatter.formatLongDate2 = function (dateTime) {
        return window.moment(dateTime).format(abp.dateTimeFormatter.getLongDate2Format());
    };

    /**
     * @description Formats a datetime to local short date. Eg: 03/02/2021
     * @param {(Date|string)} dateTime - If it's a string, make sure it's in ISO 8601 format. Eg: 2021-02-03T05:33:21Z / 2021-02-03T13:33:21+08:00
     * @returns {string} - The formatted short date.
     */
    dateTimeFormatter.formatShortDate = function (dateTime) {
        return window.moment(dateTime).format(abp.dateTimeFormatter.getShortDateFormat());
    };

    /**
     * @description Formats a datetime to local short date 2. Eg: 03 Feb 2021
     * @param {(Date|string)} dateTime - If it's a string, make sure it's in ISO 8601 format. Eg: 2021-02-03T05:33:21Z / 2021-02-03T13:33:21+08:00
     * @returns {string} - The formatted short date 2.
     */
    dateTimeFormatter.formatShortDate2 = function (dateTime) {
        return window.moment(dateTime).format(abp.dateTimeFormatter.getShortDate2Format());
    };

    /**
     * @description Formats a datetime to local long time. Eg: 05:33:21
     * @param {(Date|string)} dateTime - If it's a string, make sure it's in ISO 8601 format. Eg: 2021-02-03T05:33:21Z / 2021-02-03T13:33:21+08:00
     * @returns {string} - The formatted long time.
     */
    dateTimeFormatter.formatLongTime = function (dateTime) {
        return window.moment(dateTime).format(abp.dateTimeFormatter.getLongTimeFormat());
    };

    /**
     * @description Formats a datetime to local short time. Eg: 05:33
     * @param {(Date|string)} dateTime - If it's a string, make sure it's in ISO 8601 format. Eg: 2021-02-03T05:33:21Z / 2021-02-03T13:33:21+08:00
     * @returns {string} - The formatted short time.
     */
    dateTimeFormatter.formatShortTime = function (dateTime) {
        return window.moment(dateTime).format(abp.dateTimeFormatter.getShortTimeFormat());
    };

    //#endregion

    //#region Formats a local date with local timezone to ISO 8601 UTC

    /**
     * @description Formats a local Date object to ISO 8601 UTC datetime.
     * @param {(Date)} dateTime - Must be in "Date" data type.
     * @returns {string} - The ISO 8601 UTC datetime. Eg: 2021-02-03T05:33:21Z
     */
    dateTimeFormatter.formatUtc = function (dateTime) {
        return window.moment(dateTime).utc().format();
    };

    /**
     * @description Formats a local long date to ISO 8601 UTC datetime.
     * @param {(Date|string)} dateTime - If it's a string, make sure it's in 'long date' format. Eg: 03 February 2021
     * @returns {string} - The ISO 8601 UTC datetime. Eg: 2021-02-03
     */
    dateTimeFormatter.formatUtcFromLongDate = function (dateTime) {
        return window.moment(dateTime, abp.dateTimeFormatter.getLongDateFormat(), true).utc().format("YYYY-MM-DD");
    };

    /**
     * @description Formats a local long date 2 to ISO 8601 UTC datetime.
     * @param {(Date|string)} dateTime - If it's a string, make sure it's in 'long date 2' format. Eg: Wednesday, 03 February 2021
     * @returns {string} - The ISO 8601 UTC datetime. Eg: 2021-02-03
     */
    dateTimeFormatter.formatUtcFromLongDate2 = function (dateTime) {
        return window.moment(dateTime, abp.dateTimeFormatter.getLongDate2Format(), true).utc().format("YYYY-MM-DD");
    };

    /**
     * @description Formats a local short date to ISO 8601 UTC datetime.
     * @param {(Date|string)} dateTime - If it's a string, make sure it's in 'short date' format. Eg: 03/02/2021
     * @returns {string} - The ISO 8601 UTC datetime. Eg: 2021-02-03
     */
    dateTimeFormatter.formatUtcFromShortDate = function (dateTime) {
        return window.moment(dateTime, abp.dateTimeFormatter.getShortDateFormat(), true).utc().format("YYYY-MM-DD");
    };

    /**
     * @description Formats a local short date 2 long time to ISO 8601 UTC datetime.
     * @param {(Date|string)} dateTime - If it's a string, make sure it's in 'short date 2' format. Eg: 03 Feb 2021
     * @returns {string} - The ISO 8601 UTC datetime. Eg: 2021-02-03
     */
    dateTimeFormatter.formatUtcFromShortDate2 = function (dateTime) {
        return window.moment(dateTime, `${abp.dateTimeFormatter.getShortDate2Format()}`, true).utc().format("YYYY-MM-DD");
    };

    /**
     * @description Formats a local long time to ISO 8601 UTC datetime.
     * @param {(Date|string)} dateTime - If it's a string, make sure it's in 'long time' format. Eg: 13:33:21
     * @returns {string} - The ISO 8601 UTC datetime. Eg: T05:33:21Z
     */
    dateTimeFormatter.formatUtcFromLongTime = function (dateTime) {
        return window.moment(dateTime, abp.dateTimeFormatter.getLongTimeFormat(), true).utc().format("THH:mm:ssZ");
    };

    /**
     * @description Formats a local short time to ISO 8601 UTC datetime.
     * @param {(Date|string)} dateTime - If it's a string, make sure it's in 'short time' format. Eg: 13:33
     * @returns {string} - The ISO 8601 UTC datetime. Eg: T05:33:00Z
     */
    dateTimeFormatter.formatUtcFromShortTime = function (dateTime) {
        return window.moment(dateTime, abp.dateTimeFormatter.getShortTimeFormat(), true).utc().format("THH:mm:ssZ");
    };


    /**
     * @description Formats a local long date long time to ISO 8601 UTC datetime.
     * @param {(Date|string)} dateTime - If it's a string, make sure it's in 'long date long time' format. Eg: 03 February 2021 13:33:21
     * @returns {string} - The ISO 8601 UTC datetime. Eg: 2021-02-03T05:33:21Z
     */
    dateTimeFormatter.formatUtcFromLongDateLongTime = function (dateTime) {
        return window.moment(dateTime, `${abp.dateTimeFormatter.getLongDateFormat()} ${abp.dateTimeFormatter.getLongTimeFormat()}`, true).utc().format();
    };

    /**
     * @description Formats a local long date short time to ISO 8601 UTC datetime.
     * @param {(Date|string)} dateTime - If it's a string, make sure it's in 'long date short time' format. Eg: 03 February 2021 13:33
     * @returns {string} - The ISO 8601 UTC datetime. Eg: 2021-02-03T05:33Z
     */
    dateTimeFormatter.formatUtcFromLongDateShortTime = function (dateTime) {
        return window.moment(dateTime, `${abp.dateTimeFormatter.getLongDateFormat()} ${abp.dateTimeFormatter.getShortTimeFormat()}`, true).utc().format();
    };

    /**
     * @description Formats a local long date 2 long time to ISO 8601 UTC datetime.
     * @param {(Date|string)} dateTime - If it's a string, make sure it's in 'long date 2 long time' format. Eg: Wednesday, 03 February 2021 13:33:21
     * @returns {string} - The ISO 8601 UTC datetime. Eg: 2021-02-03T05:33:21Z
     */
    dateTimeFormatter.formatUtcFromLongDate2LongTime = function (dateTime) {
        return window.moment(dateTime, `${abp.dateTimeFormatter.getLongDate2Format()} ${abp.dateTimeFormatter.getLongTimeFormat()}`, true).utc().format();
    };

    /**
     * @description Formats a local long date 2 short time to ISO 8601 UTC datetime.
     * @param {(Date|string)} dateTime - If it's a string, make sure it's in 'long date 2 short time' format. Eg: Wednesday, 03 February 2021 13:33
     * @returns {string} - The ISO 8601 UTC datetime. Eg: 2021-02-03T05:33Z
     */
    dateTimeFormatter.formatUtcFromLongDate2ShortTime = function (dateTime) {
        return window.moment(dateTime, `${abp.dateTimeFormatter.getLongDate2Format()} ${abp.dateTimeFormatter.getShortTimeFormat()}`, true).utc().format();
    };

    /**
     * @description Formats a local short date long time to ISO 8601 UTC datetime.
     * @param {(Date|string)} dateTime - If it's a string, make sure it's in 'short date long time' format. Eg: 03/02/2021 13:33:21
     * @returns {string} - The ISO 8601 UTC datetime. Eg: 2021-02-03T05:33:21Z
     */
    dateTimeFormatter.formatUtcFromShortDateLongTime = function (dateTime) {
        return window.moment(dateTime, `${abp.dateTimeFormatter.getShortDateFormat()} ${abp.dateTimeFormatter.getLongTimeFormat()}`, true).utc().format();
    };

    /**
     * @description Formats a local short date short time to ISO 8601 UTC datetime.
     * @param {(Date|string)} dateTime - If it's a string, make sure it's in 'short date short time' format. Eg: 03/02/2021 2021 13:33
     * @returns {string} - The ISO 8601 UTC datetime. Eg: 2021-02-03T05:33Z
     */
    dateTimeFormatter.formatUtcFromShortDateShortTime = function (dateTime) {
        return window.moment(dateTime, `${abp.dateTimeFormatter.getShortDateFormat()} ${abp.dateTimeFormatter.getShortTimeFormat()}`, true).utc().format();
    };

    /**
     * @description Formats a local short date 2 long time to ISO 8601 UTC datetime.
     * @param {(Date|string)} dateTime - If it's a string, make sure it's in 'short date 2 long time' format. Eg: 03 Feb 2021 13:33:21
     * @returns {string} - The ISO 8601 UTC datetime. Eg: 2021-02-03T05:33:21Z
     */
    dateTimeFormatter.formatUtcFromShortDate2LongTime = function (dateTime) {
        return window.moment(dateTime, `${abp.dateTimeFormatter.getShortDate2Format()} ${abp.dateTimeFormatter.getLongTimeFormat()}`, true).utc().format();
    };

    /**
     * @description Formats a local short date 2 short time to ISO 8601 UTC datetime.
     * @param {(Date|string)} dateTime - If it's a string, make sure it's in 'short date 2 short time' format. Eg: 03 Feb 2021 13:33
     * @returns {string} - The ISO 8601 UTC datetime. Eg: 2021-02-03T05:33Z
     */
    dateTimeFormatter.formatUtcFromShortDate2ShortTime = function (dateTime) {
        return window.moment(dateTime, `${abp.dateTimeFormatter.getShortDate2Format()} ${abp.dateTimeFormatter.getShortTimeFormat()}`, true).utc().format();
    };

    //#endregion

    //#region Formats local date as UTC (Change UTC offset to "+0" without changing the time)

    /**
     * @description Formats a local Date object as ISO 8601 UTC datetime.
     * @param {(Date)} dateTime - Must be in "Date" data type.
     * @returns {string} - The ISO 8601 UTC datetime. Eg: 2021-02-03T05:33:21Z
     */
    dateTimeFormatter.formatAsUtc = function (dateTime) {
        return window.moment(dateTime).utcOffset(0, true).format();
    };

    /**
     * @description Formats a local long date as ISO 8601 UTC datetime.
     * @param {(Date|string)} dateTime - If it's a string, make sure it's in 'long date' format. Eg: 03 February 2021
     * @returns {string} - The ISO 8601 UTC datetime. Eg: 2021-02-03
     */
    dateTimeFormatter.formatAsUtcFromLongDate = function (dateTime) {
        return window.moment(dateTime, abp.dateTimeFormatter.getLongDateFormat(), true).utcOffset(0, true).format("YYYY-MM-DD");
    };

    /**
     * @description Formats a local long date 2 as ISO 8601 UTC datetime.
     * @param {(Date|string)} dateTime - If it's a string, make sure it's in 'long date 2' format. Eg: Wednesday, 03 February 2021
     * @returns {string} - The ISO 8601 UTC datetime. Eg: 2021-02-03
     */
    dateTimeFormatter.formatAsUtcFromLongDate2 = function (dateTime) {
        return window.moment(dateTime, abp.dateTimeFormatter.getLongDate2Format(), true).utcOffset(0, true).format("YYYY-MM-DD");
    };

    /**
     * @description Formats a local short date as ISO 8601 UTC datetime.
     * @param {(Date|string)} dateTime - If it's a string, make sure it's in 'short date' format. Eg: 03/02/2021
     * @returns {string} - The ISO 8601 UTC datetime. Eg: 2021-02-03
     */
    dateTimeFormatter.formatAsUtcFromShortDate = function (dateTime) {
        return window.moment(dateTime, abp.dateTimeFormatter.getShortDateFormat(), true).utcOffset(0, true).format("YYYY-MM-DD");
    };

    /**
     * @description Formats a local short date 2 long time as ISO 8601 UTC datetime.
     * @param {(Date|string)} dateTime - If it's a string, make sure it's in 'short date 2' format. Eg: 03 Feb 2021
     * @returns {string} - The ISO 8601 UTC datetime. Eg: 2021-02-03
     */
    dateTimeFormatter.formatAsUtcFromShortDate2 = function (dateTime) {
        return window.moment(dateTime, `${abp.dateTimeFormatter.getShortDate2Format()}`, true).utcOffset(0, true).format("YYYY-MM-DD");
    };

    /**
     * @description Formats a local long time as ISO 8601 UTC datetime.
     * @param {(Date|string)} dateTime - If it's a string, make sure it's in 'long time' format. Eg: 13:33:21
     * @returns {string} - The ISO 8601 UTC datetime. Eg: T05:33:21Z
     */
    dateTimeFormatter.formatAsUtcFromLongTime = function (dateTime) {
        return window.moment(dateTime, abp.dateTimeFormatter.getLongTimeFormat(), true).utcOffset(0, true).format("THH:mm:ssZ");
    };

    /**
     * @description Formats a local short time as ISO 8601 UTC datetime.
     * @param {(Date|string)} dateTime - If it's a string, make sure it's in 'short time' format. Eg: 13:33
     * @returns {string} - The ISO 8601 UTC datetime. Eg: T05:33:00Z
     */
    dateTimeFormatter.formatAsUtcFromShortTime = function (dateTime) {
        return window.moment(dateTime, abp.dateTimeFormatter.getShortTimeFormat(), true).utcOffset(0, true).format("THH:mm:ssZ");
    };


    /**
     * @description Formats a local long date long time as ISO 8601 UTC datetime.
     * @param {(Date|string)} dateTime - If it's a string, make sure it's in 'long date long time' format. Eg: 03 February 2021 13:33:21
     * @returns {string} - The ISO 8601 UTC datetime. Eg: 2021-02-03T05:33:21Z
     */
    dateTimeFormatter.formatAsUtcFromLongDateLongTime = function (dateTime) {
        return window.moment(dateTime, `${abp.dateTimeFormatter.getLongDateFormat()} ${abp.dateTimeFormatter.getLongTimeFormat()}`, true).utcOffset(0, true).format();
    };

    /**
     * @description Formats a local long date short time as ISO 8601 UTC datetime.
     * @param {(Date|string)} dateTime - If it's a string, make sure it's in 'long date short time' format. Eg: 03 February 2021 13:33
     * @returns {string} - The ISO 8601 UTC datetime. Eg: 2021-02-03T05:33Z
     */
    dateTimeFormatter.formatAsUtcFromLongDateShortTime = function (dateTime) {
        return window.moment(dateTime, `${abp.dateTimeFormatter.getLongDateFormat()} ${abp.dateTimeFormatter.getShortTimeFormat()}`, true).utcOffset(0, true).format();
    };

    /**
     * @description Formats a local long date 2 long time as ISO 8601 UTC datetime.
     * @param {(Date|string)} dateTime - If it's a string, make sure it's in 'long date 2 long time' format. Eg: Wednesday, 03 February 2021 13:33:21
     * @returns {string} - The ISO 8601 UTC datetime. Eg: 2021-02-03T05:33:21Z
     */
    dateTimeFormatter.formatAsUtcFromLongDate2LongTime = function (dateTime) {
        return window.moment(dateTime, `${abp.dateTimeFormatter.getLongDate2Format()} ${abp.dateTimeFormatter.getLongTimeFormat()}`, true).utcOffset(0, true).format();
    };

    /**
     * @description Formats a local long date 2 short time as ISO 8601 UTC datetime.
     * @param {(Date|string)} dateTime - If it's a string, make sure it's in 'long date 2 short time' format. Eg: Wednesday, 03 February 2021 13:33
     * @returns {string} - The ISO 8601 UTC datetime. Eg: 2021-02-03T05:33Z
     */
    dateTimeFormatter.formatAsUtcFromLongDate2ShortTime = function (dateTime) {
        return window.moment(dateTime, `${abp.dateTimeFormatter.getLongDate2Format()} ${abp.dateTimeFormatter.getShortTimeFormat()}`, true).utcOffset(0, true).format();
    };

    /**
     * @description Formats a local short date long time as ISO 8601 UTC datetime.
     * @param {(Date|string)} dateTime - If it's a string, make sure it's in 'short date long time' format. Eg: 03/02/2021 13:33:21
     * @returns {string} - The ISO 8601 UTC datetime. Eg: 2021-02-03T05:33:21Z
     */
    dateTimeFormatter.formatAsUtcFromShortDateLongTime = function (dateTime) {
        return window.moment(dateTime, `${abp.dateTimeFormatter.getShortDateFormat()} ${abp.dateTimeFormatter.getLongTimeFormat()}`, true).utcOffset(0, true).format();
    };

    /**
     * @description Formats a local short date short time as ISO 8601 UTC datetime.
     * @param {(Date|string)} dateTime - If it's a string, make sure it's in 'short date short time' format. Eg: 03/02/2021 2021 13:33
     * @returns {string} - The ISO 8601 UTC datetime. Eg: 2021-02-03T05:33Z
     */
    dateTimeFormatter.formatAsUtcFromShortDateShortTime = function (dateTime) {
        return window.moment(dateTime, `${abp.dateTimeFormatter.getShortDateFormat()} ${abp.dateTimeFormatter.getShortTimeFormat()}`, true).utcOffset(0, true).format();
    };

    /**
     * @description Formats a local short date 2 long time as ISO 8601 UTC datetime.
     * @param {(Date|string)} dateTime - If it's a string, make sure it's in 'short date 2 long time' format. Eg: 03 Feb 2021 13:33:21
     * @returns {string} - The ISO 8601 UTC datetime. Eg: 2021-02-03T05:33:21Z
     */
    dateTimeFormatter.formatAsUtcFromShortDate2LongTime = function (dateTime) {
        return window.moment(dateTime, `${abp.dateTimeFormatter.getShortDate2Format()} ${abp.dateTimeFormatter.getLongTimeFormat()}`, true).utcOffset(0, true).format();
    };

    /**
     * @description Formats a local short date 2 short time as ISO 8601 UTC datetime.
     * @param {(Date|string)} dateTime - If it's a string, make sure it's in 'short date 2 short time' format. Eg: 03 Feb 2021 13:33
     * @returns {string} - The ISO 8601 UTC datetime. Eg: 2021-02-03T05:33Z
     */
    dateTimeFormatter.formatAsUtcFromShortDate2ShortTime = function (dateTime) {
        return window.moment(dateTime, `${abp.dateTimeFormatter.getShortDate2Format()} ${abp.dateTimeFormatter.getShortTimeFormat()}`, true).utcOffset(0, true).format();
    };

    //#endregion

    //#region Formats UTC as local date (Basically showing UTC in a local datetime format while retaining the UTC (UTC offset 0) timezone. Eg: converts 2000-01-01T00:00Z to 2000-01-01 00:00 or 2000-01-01 12:00AM depending on format and 2000-01-01T00:00+08:00 to 1999-12-31 16:00 or 31/12/1999 4:00PM depending on format)

    /**
     * @description Formats an ISO 8601 UTC datetime as a local long date in UTC timezone.
     * @param {string} dateTime - An ISO 8601 UTC datetime. Eg: 2021-02-03T13:33:21Z
     * @returns {string} - The local datetime in 'long date' format in UTC timezone. Eg: 03 February 2021
     */
    dateTimeFormatter.formatAsLocalLongDate = function (dateTime) {
        return window.moment(dateTime).utcOffset(0).format(abp.dateTimeFormatter.getLongDateFormat());
    };

    /**
     * @description Formats an ISO 8601 UTC datetime as a local long date 2 in UTC timezone.
     * @param {string} dateTime - An ISO 8601 UTC datetime. Eg: 2021-02-03T13:33:21Z
     * @returns {string} - The local datetime in 'long date 2' format in UTC timezone. Eg: Wednesday, 03 February 2021
     */
    dateTimeFormatter.formatAsLocalLongDate2 = function (dateTime) {
        return window.moment(dateTime).utcOffset(0).format(abp.dateTimeFormatter.getLongDate2Format());
    };

    /**
     * @description Formats an ISO 8601 UTC datetime as a local short date in UTC timezone.
     * @param {string} dateTime - An ISO 8601 UTC datetime. Eg: 2021-02-03T13:33:21Z
     * @returns {string} - The local datetime in 'short date' format in UTC timezone. Eg: 03/02/2021
     */
    dateTimeFormatter.formatAsLocalShortDate = function (dateTime) {
        return window.moment(dateTime).utcOffset(0).format(abp.dateTimeFormatter.getShortDateFormat());
    };

    /**
     * @description Formats an ISO 8601 UTC datetime as a local short date 2 in UTC timezone.
     * @param {string} dateTime - An ISO 8601 UTC datetime. Eg: 2021-02-03T13:33:21Z
     * @returns {string} - The local datetime in 'short date 2' format in UTC timezone. Eg: 03 Feb 2021
     */
    dateTimeFormatter.formatAsLocalShortDate2 = function (dateTime) {
        return window.moment(dateTime).utcOffset(0).format(abp.dateTimeFormatter.getShortDate2Format());
    };

    /**
     * @description Formats an ISO 8601 UTC datetime as a local long time in UTC timezone.
     * @param {string} dateTime - An ISO 8601 UTC datetime. Eg: 2021-02-03T13:33:21Z
     * @returns {string} - The local datetime in 'long time' format in UTC timezone. Eg: 13:33:21
     */
    dateTimeFormatter.formatAsLocalLongTime = function (dateTime) {
        return window.moment(dateTime).utcOffset(0).format(abp.dateTimeFormatter.getLongTimeFormat());
    };

    /**
     * @description Formats an ISO 8601 UTC datetime as a local short time in UTC timezone.
     * @param {string} dateTime - An ISO 8601 UTC datetime. Eg: 2021-02-03T13:33:21Z
     * @returns {string} - The local datetime in 'short time' format in UTC timezone. Eg: 13:33
     */
    dateTimeFormatter.formatAsLocalShortTime = function (dateTime) {
        return window.moment(dateTime).utcOffset(0).format(abp.dateTimeFormatter.getShortTimeFormat());
    };

    /**
     * @description Formats an ISO 8601 UTC datetime as a local long date long time in UTC timezone.
     * @param {string} dateTime - An ISO 8601 UTC datetime. Eg: 2021-02-03T13:33:21Z
     * @returns {string} - The local datetime in 'long date long time' format in UTC timezone. Eg: 03 February 2021 13:33:21
     */
    dateTimeFormatter.formatAsLocalLongDateLongTime = function (dateTime) {
        return window.moment(dateTime).utcOffset(0).format(`${abp.dateTimeFormatter.getLongDateFormat()} ${abp.dateTimeFormatter.getLongTimeFormat()}`);
    };

    /**
     * @description Formats an ISO 8601 UTC datetime as a local long date short time in UTC timezone.
     * @param {string} dateTime - An ISO 8601 UTC datetime. Eg: 2021-02-03T13:33:21Z
     * @returns {string} - The local datetime in 'long date short time' format in UTC timezone. Eg: 03 February 2021 13:33
     */
    dateTimeFormatter.formatAsLocalLongDateShortTime = function (dateTime) {
        return window.moment(dateTime).utcOffset(0).format(`${abp.dateTimeFormatter.getLongDateFormat()} ${abp.dateTimeFormatter.getShortTimeFormat()}`);
    };

    /**
     * @description Formats an ISO 8601 UTC datetime as a local long date 2 long time in UTC timezone.
     * @param {string} dateTime - An ISO 8601 UTC datetime. Eg: 2021-02-03T13:33:21Z
     * @returns {string} - The local datetime in 'long date 2 long time' format in UTC timezone. Eg: Wednesday, 03 February 2021 13:33:21
     */
    dateTimeFormatter.formatAsLocalLongDate2LongTime = function (dateTime) {
        return window.moment(dateTime).utcOffset(0).format(`${abp.dateTimeFormatter.getLongDate2Format()} ${abp.dateTimeFormatter.getLongTimeFormat()}`);
    };

    /**
     * @description Formats an ISO 8601 UTC datetime as a local long date 2 short time in UTC timezone.
     * @param {string} dateTime - An ISO 8601 UTC datetime. Eg: 2021-02-03T13:33:21Z
     * @returns {string} - The local datetime in 'long date 2 short time' format in UTC timezone. Eg: Wednesday, 03 February 2021 13:33
     */
    dateTimeFormatter.formatAsLocalLongDate2ShortTime = function (dateTime) {
        return window.moment(dateTime).utcOffset(0).format(`${abp.dateTimeFormatter.getLongDate2Format()} ${abp.dateTimeFormatter.getShortTimeFormat()}`);
    };

    /**
     * @description Formats an ISO 8601 UTC datetime as a local short date long time in UTC timezone.
     * @param {string} dateTime - An ISO 8601 UTC datetime. Eg: 2021-02-03T13:33:21Z
     * @returns {string} - The local datetime in 'short date long time' format in UTC timezone. Eg: 03/02/2021 13:33:21
     */
    dateTimeFormatter.formatAsLocalShortDateLongTime = function (dateTime) {
        return window.moment(dateTime).utcOffset(0).format(`${abp.dateTimeFormatter.getShortDateFormat()} ${abp.dateTimeFormatter.getLongTimeFormat()}`);
    };

    /**
     * @description Formats an ISO 8601 UTC datetime as a local short date short time in UTC timezone.
     * @param {string} dateTime - An ISO 8601 UTC datetime. Eg: 2021-02-03T13:33:21Z
     * @returns {string} - The local datetime in 'short date short time' format in UTC timezone. Eg: 03/02/2021 13:33
     */
    dateTimeFormatter.formatAsLocalShortDateShortTime = function (dateTime) {
        return window.moment(dateTime).utcOffset(0).format(`${abp.dateTimeFormatter.getShortDateFormat()} ${abp.dateTimeFormatter.getShortTimeFormat()}`);
    };

    /**
     * @description Formats an ISO 8601 UTC datetime as a local short date 2 long time in UTC timezone.
     * @param {string} dateTime - An ISO 8601 UTC datetime. Eg: 2021-02-03T13:33:21Z
     * @returns {string} - The local datetime in 'short date 2 long time' format in UTC timezone. Eg: 03 Feb 2021 13:33:21
     */
    dateTimeFormatter.formatAsLocalShortDate2LongTime = function (dateTime) {
        return window.moment(dateTime).utcOffset(0).format(`${abp.dateTimeFormatter.getShortDate2Format()} ${abp.dateTimeFormatter.getLongTimeFormat()}`);
    };

    /**
     * @description Formats an ISO 8601 UTC datetime as a local short date 2 short time in UTC timezone.
     * @param {string} dateTime - An ISO 8601 UTC datetime. Eg: 2021-02-03T13:33:21Z
     * @returns {string} - The local datetime in 'short date 2 short time' format in UTC timezone. Eg: 03 Feb 2021 13:33
     */
    dateTimeFormatter.formatAsLocalShortDate2ShortTime = function (dateTime) {
        return window.moment(dateTime).utcOffset(0).format(`${abp.dateTimeFormatter.getShortDate2Format()} ${abp.dateTimeFormatter.getShortTimeFormat()}`);
    };

    //#endregion

    abp.dateTimeFormatter = dateTimeFormatter;
})(jQuery, abp);
